import { KatRadiobuttonGroup } from '@amzn/katal-react';
import styles from './StyledRadioButtonGroup.module.css';

interface StyledRadioButtonGroupProps extends KatRadiobuttonGroup.Props {}

const StyledRadioButtonGroup = (katRadioButtonGroupProps: StyledRadioButtonGroupProps) => {
  return (
    <div className={styles.container}>
      <KatRadiobuttonGroup {...katRadioButtonGroupProps} />
    </div>
  );
};

export { StyledRadioButtonGroup };
